import { Monthly10k } from '@daymade/common-lib/constants';
import { useUserStore } from 'hooks/stores/useUserStore';
import Link from 'next/link';
import { CSSProperties } from 'react';
import { ASSET_PREFIX } from 'utils/constants';

interface Props {
  style?: CSSProperties | undefined;
}

const HeaderOtherGamesList = (props: Props) => {
  const { isInMonthlyRaffle } = useUserStore();
  // The HeaderOtherGamesList wraps its previous implementation, which was in a .js file, to try and preserve the git
  // history since we have to rename the file from .js to .tsx. If we did not wrap it, then many lines will be indented
  return (
    <HeaderOtherGamesListInner
      {...props}
      showMonthly10kOption={isInMonthlyRaffle}
    />
  );
};

const HeaderOtherGamesListInner = ({
  style,
  showMonthly10kOption,
}: Props & { showMonthly10kOption: boolean }) => (
  <div className="headerOtherGamesList flexLeftAligned" style={style}>
    <Link href="/">
      <div className="gameContainer">
        <img
          className="gameImage"
          src={`${ASSET_PREFIX}/images/other-games-icons/weekly-draw.svg`}
          alt=""
        />

        <a className="flexLeftAligned">
          <div className="categoryHeading">Weekly Draws</div>

          <div className="categorySubheading">Tuesdays and Fridays</div>
        </a>
      </div>
    </Link>

    <Link href="/token-town">
      <div className="gameContainer">
        <img
          className="gameImage"
          src={`${ASSET_PREFIX}/images/game-selector/token-town-thumbnail.svg`}
          alt=""
        />

        <a className="flexLeftAligned">
          <div className="categoryHeading">Token Town</div>

          <div className="categorySubheading">
            Raffles, mini games & Free Daily Draw
          </div>
        </a>
      </div>
    </Link>

    {showMonthly10kOption && (
      <Link href={Monthly10k.urlPath}>
        <div className="gameContainer">
          <img
            className="gameImage"
            src={`${ASSET_PREFIX}/images/game-selector/monthly-10k-thumbnail.svg`}
            alt=""
          />

          <a className="flexLeftAligned">
            <div className="categoryHeading">Monthly £10K giveaway</div>

            <div className="categorySubheading">
              Loyalty rewarded: guaranteed £10k prize won every month
            </div>
          </a>
        </div>
      </Link>
    )}

    <style jsx>
      {`
        .headerOtherGamesList {
          margin: 1em auto;
          width: 100%;
        }

        .gameContainer {
          cursor: pointer;
          display: flex;
          align-items: center;
          margin: 1em;
        }

        .gameImage {
          margin-right: 1.2em;
          width: 65px;
          height: 56px;
          object-fit: contain;
        }

        .categoryHeading {
          font-weight: 900;
        }

        .categorySubheading {
          font-weight: 600;
          font-size: 0.85em;
          text-align: left;
          white-space: pre-wrap;
          flex-grow: 1;
          width: 100%;
        }
      `}
    </style>
  </div>
);

export default HeaderOtherGamesList;
